import { Layers, Calculator, Building2, Stethoscope, Smartphone, Globe, ShoppingCart } from 'lucide-react';

export const SERVICE_ICONS = {
  layers: { label: 'أنظمة وحلول متكاملة', icon: Layers },
  calculator: { label: 'محاسبة', icon: Calculator },
  hospital: { label: 'طبي / مستشفى', icon: Stethoscope },
  construction: { label: 'مقاولات / بناء', icon: Building2 },
  building: { label: 'عقارات / مباني', icon: Building2 },
  smartphone: { label: 'تطبيقات جوال', icon: Smartphone },
  shopping: { label: 'تجارة إلكترونية', icon: ShoppingCart },
  globe: { label: 'مواقع ويب', icon: Globe },
};

export const SERVICE_COLORS = {
  blue: { label: 'أزرق', gradient: 'from-blue-500 to-cyan-500', badge: 'bg-blue-500/15 text-blue-300 border-blue-500/25' },
  green: { label: 'أخضر', gradient: 'from-emerald-500 to-green-500', badge: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/25' },
  red: { label: 'أحمر', gradient: 'from-rose-500 to-red-500', badge: 'bg-rose-500/15 text-rose-300 border-rose-500/25' },
  orange: { label: 'برتقالي', gradient: 'from-amber-500 to-orange-500', badge: 'bg-amber-500/15 text-amber-300 border-amber-500/25' },
  purple: { label: 'بنفسجي', gradient: 'from-violet-500 to-purple-500', badge: 'bg-violet-500/15 text-violet-300 border-violet-500/25' },
  cyan: { label: 'سماوي', gradient: 'from-cyan-500 to-sky-500', badge: 'bg-cyan-500/15 text-cyan-300 border-cyan-500/25' },
};

export const getServiceIcon = (key) => (SERVICE_ICONS[key] || SERVICE_ICONS.layers).icon;
export const getServiceColor = (key) => SERVICE_COLORS[key] || SERVICE_COLORS.blue;
